import PropTypes from 'prop-types';

import Balloon from '../../../assets/balloon.svg';
import styles from './styles.module.css';

function KitoBalloon({ children, ...rest }) {
    const background = {
        backgroundImage: `url(${Balloon})`,
        backgroundSize: '100% 100%',
        backgroundRepeat: 'no-repeat',
        
        ...rest
    }
    return (
    <div className={styles.kitoBalloon} style={background}>
      {children}
    </div>
  );
}

KitoBalloon.propTypes = {
  children: PropTypes.node.isRequired,
  rest: PropTypes.object
}

export default KitoBalloon;